// Ícone de gôndola para "Gerenciar zonas e módulos".
//
// Existe porque esse botão usava o mesmo SettingOutlined de "Gerenciar zonas e
// categorias", e os dois ficavam indistinguíveis lado a lado. Nenhum ícone do
// Ant Design é uma gôndola: DatabaseOutlined é o mais próximo em forma, mas ao
// lado de texto lê como banco de dados.
//
// Segue a convenção do antd — 1em e currentColor — para herdar tamanho e cor do
// contexto, inclusive quando o botão está selecionado.
export default function GondolaIcon({ style, ...props }) {
  return (
    <span
      role="img"
      aria-label="gôndola"
      className="anticon"
      style={style}
      {...props}>
      <svg
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable="false"
        aria-hidden="true">
        {/* montantes laterais */}
        <path d="M4 3v18M20 3v18" />
        {/* três prateleiras */}
        <path d="M4 8h16M4 14h16M4 20h16" />
        {/* produtos na prateleira de cima e do meio */}
        <path d="M8 8V5.5h2.5V8M14 8V6h2V8M8 14v-2.5h2V14M13 14v-3h3v3" />
      </svg>
    </span>
  );
}
